import { useContext } from "react";

import { GatewaysContext } from "./GatewaysContext";

export const useGateways = () => useContext(GatewaysContext);
